export default __webpack_public_path__ + "content/media/25.1e723bde.jpg";